<div class="zones-list-item"
     role="button"
     [class.is-changing]="isChanging()"
     [class.is-disabled]="isDisabled()"
     (click)="onClick()">
    @if (isChanging()) {
        <div class="change-overlay"></div>
    }
    <div class="wrapper">
        <div class="font-bold index">{{ zonesListItem().index }}</div>
        <div class="icon-wrapper bg-style">
            <zone-icon [name]="zonesListItem().icon" [size]="16"/>
        </div>
        <div>{{ zonesListItem().name }}</div>
    </div>
    @if (isChanging()) {
        <div class="wrapper">
            <loader [dark]="true" class="loader" [size]="32"/>
        </div>
    }
    <div class="wrapper">
        <app-chip [text]="zonesListItem().statusText" [background]="zonesListItem().statusBg"/>
        <img class="arrow-icon" ngSrc="/assets/img/icons/black-arrow.svg"
             priority="true" width="24" height="24" alt=""/>
    </div>
</div>
